interface RecordFileSource {
  senderName?: string | null;
  senderPhone?: string | null;
  ringingAt?: string | null;
}

interface RecordActionSource {
  callStatus?: string | null;
}

const MIME_EXTENSION_MAP: Record<string, string> = {
  'audio/mpeg': 'mp3',
  'audio/mp3': 'mp3',
  'audio/wav': 'wav',
  'audio/wave': 'wav',
  'audio/x-wav': 'wav',
  'audio/ogg': 'ogg',
  'audio/webm': 'webm',
  'audio/aac': 'aac',
  'audio/flac': 'flac',
  'audio/mp4': 'm4a',
};

const sanitizeFileNamePart = (value: string) => {
  const sanitized = value
    .replace(/[\\/:*?"<>|]/g, '_')
    .replace(/\s+/g, ' ')
    .trim();

  return sanitized || '미등록자';
};

const formatRecordDate = (dateValue?: string | null) => {
  if (!dateValue) return '날짜없음';

  const date = new Date(dateValue);
  if (Number.isNaN(date.getTime())) return '날짜없음';

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
};

const getBlobExtension = (blob: Blob) => MIME_EXTENSION_MAP[blob.type] || 'wav';

export const buildRecordFileName = (call: RecordFileSource, blob: Blob) => {
  const caller = sanitizeFileNamePart(call.senderName || call.senderPhone || '미등록자');
  const date = formatRecordDate(call.ringingAt);
  const extension = getBlobExtension(blob);

  return `통화녹취_${caller}_${date}.${extension}`;
};

export const buildStereoRecordFileName = (call: RecordFileSource, blob: Blob) => {
  const caller = sanitizeFileNamePart(call.senderName || call.senderPhone || '미등록자');
  const date = formatRecordDate(call.ringingAt);
  const extension = getBlobExtension(blob);

  return `통화녹취_스테레오_${caller}_${date}.${extension}`;
};

export const isRecordActionDisabled = (call: RecordActionSource) => call.callStatus === 'MISSED';

export const saveBlobAsFile = (blob: Blob, fileName: string) => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');

  link.href = url;
  link.download = fileName;
  link.style.display = 'none';

  try {
    document.body.appendChild(link);
    link.click();
  } finally {
    if (link.parentNode) {
      document.body.removeChild(link);
    }
    URL.revokeObjectURL(url);
  }
};
